import { AlertMessageDialogActionType } from "../actiontype/alert-message-dialog.actiontype";

const initialState = {
    message: '',
    open: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case AlertMessageDialogActionType.OPEN_ALERT_MESSAGE_DIALOG:
            return {
                ...state,
                open: true,
                message: action.payload
            };
        case AlertMessageDialogActionType.CLOSE_ALERT_MESSAGE_DIALOG:
            return {
                ...state,
                open: false,
                message: ''
            };
        default:
            return {
                ...state,
            };
    }
}
